//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      img: [
        '../../static/imageother/home/index_tab_home_default.png',
        '../../static/imageother/home/index_tab_plice_default.png',
        '../../static/imageother/home/index_tab_list_default.png',
        '../../static/imageother/home/index_tab_user_default.png',
        '../../static/imageother/home/index_tab_people_default.png'
      ],
      activeImg: [
        '../../static/imageother/home/index_tab_home_selected.png',
        '../../static/imageother/home/index_tab_plice_selected.png',
        '../../static/imageother/home/index_tab_list_selected.png',
        '../../static/imageother/home/index_tab_user_selected.png',
        '../../static/imageother/home/index_tab_people_selected.png'
      ],
      // 添加设备
      showAddImg: true,
      showToast: false,
      showAddText: true,
      add: {
        deviceCode: '',
        devicephone: '',
        dname: '',
        relativeadd: ''
      },
      addWarn: false,
      warnText: '',
      showAdd: false,
      addText: '添加成功',
      host: '',
      // 提示
      hintShow: false,
      hintObj: ''
    }
  },
  created () {
    this.golobleObject.getHintOpen = this.getHintOpenShow
    this.host = window.location.host
  },
  methods: {
    getHintOpenShow (obj) {
      console.log(99, obj)
      this.hintObj = obj
      this.hintShow = true
    },
    openSubscribeSuccess (e) {
      alert('成功')
      this.showToast = false
      this.showAddText = true
    },
    openSubscribeError (e) {
      alert('订阅失败', JSON.stringify(e).detail.errMsg)
      this.showToast = false
    },
    addShowDevice () {
      this.showAddText = true
      this.showToast = true
    },
    scanner () {
      let vm = this
      // eslint-disable-next-line no-undef
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success (res) {
          // console.log(res)
          // var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          if (res.resultStr.includes('IMEI=')) {
            let result = res.resultStr.split('IMEI=')
            console.log(result)
            let code = result[1]
            if (code) {
              vm.add.deviceCode = code
            }
          } else if (res.resultStr.includes('imei=')) {
            let result = res.resultStr.split('imei=')
            console.log(result)
            let code = result[1]
            if (code) {
              vm.add.deviceCode = code
            }
          } else {
            vm.add.deviceCode = res.resultStr
          }
          // if (res.resultStr.includes(';')) {
          //   let code = res.resultStr.split(';')
          //   if (code.length) {
          //     vm.add.deviceCode = code[0]
          //   } else {
          //     vm.add.deviceCode = res.resultStr
          //   }
          // } else if (res.resultStr.includes(',')) {
          //   let code = res.resultStr.split(',')
          //   if (code.length) {
          //     vm.add.deviceCode = code[1]
          //   } else {
          //     vm.add.deviceCode = res.resultStr
          //   }
          // } else {
          //   vm.add.deviceCode = res.resultStr
          // }
        },
        error (err) {
          alert(JSON.stringify(err))
        }
      })
    },
    closeAdd () {
      this.showAddText = true
      this.showToast = false
      this.add = {
        deviceCode: '',
        devicephone: '',
        dname: '',
        relativeadd: ''
      }
    },
    // 添加主设备
    addDevice () {
      // this.showAddText = false
      if (this.add.deviceCode === '') {
        this.addWarn = true
        this.warnText = '设备码'
      } else if (this.add.dname === '') {
        this.addWarn = true
        this.warnText = '设备名称'
      } else {
        this.$http.post(this.base + 'adddevice?token=' + this.$store.getters.get_token, {
          deviceid: this.add.deviceCode,
          name: this.add.dname,
          devicephone: this.add.devicephone,
          relativeadd: this.add.relativeadd
        }).then(res => {
          if (res.data.code === 200) {
            // this.showAddText = false // 暂时取消微信报警通知
            this.showAdd = true
            if (this.$route.path === '/Device') {
              this.golobleObject.addDeviceLoad()
            }
            this.showToast = false // 暂时直接关闭弹窗
            this.add = {
              deviceCode: '',
              devicephone: '',
              dname: '',
              relativeadd: ''
            }
          } else {
            this.addWarn = true
            this.warnText = res.data.msg
          }
        }).catch(err => {
          this.addWarn = true
          this.warnText = '失败'
          console.log(err)
        })
      }
    },
    loginOut () {
      let url = ''
      let host = window.location.host
      if (host === 'aimtycloud.anfangwx.aimtyiot.cn') { // 艾米安防云
        url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx78dc92678be7c2e6&redirect_uri=http%3A%2F%2Faimtycloud.anfangwx.aimtyiot.cn&response_type=code&scope=snsapi_base&#wechat_redirect'
      } else if (host === 'anfangwxtest.aimtyiot.cn') { // 测试
        url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd4c4de465ee2a3df&redirect_uri=http%3A%2F%2Fanfangwxtest.aimtyiot.cn&response_type=code&scope=snsapi_base&#wechat_redirect'
      } else {
        url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd4c4de465ee2a3df&redirect_uri=http%3A%2F%2Fanfangwx.aimtyiot.cn&response_type=code&scope=snsapi_base&#wechat_redirect'
      }
      this.closeSub()
      if (this.isWx()) {
        this.$store.commit('set_token', '')
        this.$store.commit('set_openid', '')
        location.assign(url)
        this.hintShow = false
      } else {
        this.$store.commit('set_token', '')
        this.$store.commit('set_openid', '')
        this.$router.push('/')
        this.hintShow = false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/Home.vue